import { createContext, useContext, ReactNode } from "react";

type ContentPlayerContextProps = Omit<SignageContentPlayerProviderProps, "children">;

const contentPlayerContext = createContext<ContentPlayerContextProps | null>(null);
const { Provider } = contentPlayerContext;

export type SignageContentPlayerProviderProps = {
  children?: ReactNode;
  setMusicVolume: (volume: number) => void;
  loading: ReactNode;
  hasInteracted: boolean;
};

export function SignageContentPlayerProvider({ children, ...props }: SignageContentPlayerProviderProps) {
  return (
    <Provider
      value={props}
    >
      {children}
    </Provider>
  );
}

export const useContentPlayer = () => {
  const context = useContext(contentPlayerContext);
  if (!context) throw "useContentPlayer must be used within a ContentPlayerProvider";
  return context;
};